export default (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
    <path
      fill="currentColor"
      d="M11.808 31.994V15.269H9v-3.98h2.808V9.953c-.007-1.29.2-2.573.61-3.795a7.5 7.5 0 0 1 1.948-3.12 7.035 7.035 0 0 1 2.677-1.572A9.22 9.22 0 0 1 19.951 1 12.965 12.965 0 0 1 23 1.323l-.215 4.185a7.954 7.954 0 0 0-1.69-.175 3.26 3.26 0 0 0-1.557.318A3.3 3.3 0 0 0 18.31 6.67a5.126 5.126 0 0 0-.83 3.017v1.608h4.3v3.98h-4.252V32l-5.72-.006Z"
    />
  </svg>
);
